import { createIcon } from '@chakra-ui/react'

export const OpenCodeLogo = createIcon({
  displayName: 'OpenCodeLogo',
  viewBox: '0 0 240 300',
  path: (
    <>
      <g clipPath="url(#clip0_1401_86274)">
        <mask
          id="mask0_1401_86274"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="240"
          height="300"
        >
          <path d="M240 0H0V300H240V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1401_86274)">
          <path d="M180 240H60V120H180V240Z" fill="#CFCECD" />
          <path
            d="M180 60H60V240H180V60ZM240 300H0V0H240V300Z"
            fill="#211E1E"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1401_86274">
          <rect width="240" height="300" fill="currentColor" />
        </clipPath>
      </defs>
    </>
  ),
})
